import type { AnalyticsEventPayload, AnalyticsUserProperties } from '@/services/analytics';

export type AnalyticsEventContext = AnalyticsEventPayload & {
  billing_interval_at_event: string;
  billing_product_at_event: string;
  billing_state_at_event: string;
  growth_popup_participant_at_event: boolean;
  growth_popup_variant_at_event: string;
  user_role_at_event: string;
};

const DEFAULT_ANALYTICS_EVENT_CONTEXT: AnalyticsEventContext = {
  billing_interval_at_event: 'none',
  billing_product_at_event: 'none',
  billing_state_at_event: 'anonymous',
  growth_popup_participant_at_event: false,
  growth_popup_variant_at_event: 'unassigned',
  user_role_at_event: 'anonymous',
};

function getStringProperty(properties: AnalyticsUserProperties | undefined, key: string, fallback: string): string {
  const value = properties?.[key];
  return typeof value === 'string' && value.length > 0 ? value : fallback;
}

export function buildAnalyticsEventContext(userProperties: AnalyticsUserProperties | undefined): AnalyticsEventContext {
  return {
    billing_interval_at_event: getStringProperty(
      userProperties,
      'billing_interval',
      DEFAULT_ANALYTICS_EVENT_CONTEXT.billing_interval_at_event,
    ),
    billing_product_at_event: getStringProperty(
      userProperties,
      'billing_product',
      DEFAULT_ANALYTICS_EVENT_CONTEXT.billing_product_at_event,
    ),
    billing_state_at_event: getStringProperty(
      userProperties,
      'billing_state',
      DEFAULT_ANALYTICS_EVENT_CONTEXT.billing_state_at_event,
    ),
    growth_popup_participant_at_event: userProperties?.growth_popup_participant === true,
    growth_popup_variant_at_event: getStringProperty(
      userProperties,
      'growth_popup_variant',
      DEFAULT_ANALYTICS_EVENT_CONTEXT.growth_popup_variant_at_event,
    ),
    user_role_at_event: getStringProperty(
      userProperties,
      'user_role',
      DEFAULT_ANALYTICS_EVENT_CONTEXT.user_role_at_event,
    ),
  };
}
